import { OrganType } from '@nkr/enums/organ-type';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { FormEvent } from 'react';
import { Nav } from 'react-bootstrap';
import { MajorNavWrapper, MajorNavItemWrapper } from './styles';

interface IProps {
    activeKey: string,
    centerId: number,
    recipientAlias: string,
    recipientId?: number,
    voucherHolderFullname?: string,
    hasRecipientShield: boolean,
    isAdmin: boolean,
    onTabSelect: (key: string) => void
}

const RecipientsNav = (props: IProps) => {
    const { app } = useAppHookContext();

    const handleSelect = (e: FormEvent<Nav>) => {
        props.onTabSelect(e['eventKey']);
    };

    const { activeKey, centerId, recipientAlias, voucherHolderFullname } = props;

    const isProfile = ['POTENTIAL-DONORS', 'EVALUATE-DONOR', 'EVALUATE-REXM', 'EVALUATE-MATCH', 'RECIPIENT-PROFILE', 'PROFILE', 'TOOLBOX'].indexOf(activeKey) >= 0 && recipientAlias != '';

    const isVoucherDetails = ['VOUCHER-HOLDER-EDIT'].indexOf(activeKey) >= 0 && voucherHolderFullname != '';

    const hrefPrefix = props.isAdmin ? '/admin' : '/center/' + centerId;

    const isNkr = app.site.organType == OrganType.Kidney;

    const tabs = [
        { eventKey: 'DONOR-PRE-SELECT', href: '/center/' + centerId + '/recipients/donor-pre-select', label: <>Donor Pre-Select</>, show: isNkr && props.isAdmin == false },
        { eventKey: 'VOUCHER-HOLDERS', href: hrefPrefix + '/recipients/voucher-holders', label: <>Voucher Holders</>, show: isNkr },
        { eventKey: 'RECIPIENT-LIST', href: '/center/' + centerId + '/recipients', label: <>Recipients</>, show: isNkr },
        { eventKey: activeKey, href: `center/${centerId}/recipient/${props.recipientId}/profile/general`, label: <>Recipient [{recipientAlias}]</>, show: isProfile },
        { eventKey: 'RECIPIENT-SHIELD', href: '/center/' + centerId + '/recipients/recipient-shield', label: <>Recipient Shield</>, show: props.hasRecipientShield },
        { eventKey: 'IMPORT-WAITLIST', href: '/center/' + centerId + '/recipients/import-waitlist', label: <>Import Waitlist</>, show: isNkr },
        { eventKey: 'PATIENT-INTAKE-LIST', href: '/center/' + centerId + '/recipients/patient-intake', label: <>Patient Intake</>, show: isNkr },
        { eventKey: activeKey, href: `center/${centerId}/recipients`, label: <>Voucher Details [{voucherHolderFullname}]</>, show: isVoucherDetails },
        { eventKey: 'DONOR-SHIELD-DIRECT', href: '/center/' + centerId + '/recipients/donor-shield-direct', label: <>Donor Shield Direct</>, show: !isNkr },
    ]

    return (
        <MajorNavWrapper className='no-print' bsStyle='tabs' style={{ marginBottom: -1 }} activeKey={activeKey} onSelect={handleSelect}>
            {tabs.filter(x => x.show).map((item, index) =>
                <MajorNavItemWrapper key={'recipient-nav-' + index} eventKey={item.eventKey} href={item.href}>
                    {item.label}
                </MajorNavItemWrapper>
            )}
        </MajorNavWrapper>
    );
}

export default RecipientsNav;